import { api } from 'shared/api'

import { templateInstallationSchemas } from './schemas'

export const templateInstallationsApi = {
  fetch: api.account.createGet({
    url: '/template/installationList',
    schemas: templateInstallationSchemas.fetch,
  }),
  enableTemplateForPage: api.account.createPost({
    url: '/template/enableTemplateForPage',
    schemas: templateInstallationSchemas.enableTemplateForPage,
  }),
  disableTemplateForPage: api.account.createPost({
    url: '/template/disableTemplateForPage',
    schemas: templateInstallationSchemas.disableTemplateForPage,
  }),
}
